export const GPT_HEAD_CONDITIONS_TREATMENT_PAGE = `
// list of all breakpoints we are using in the ads
// size property corresponds to sizeMapping used in the ad slots
// mq property lists the mediaquery this size should be visible to
const adBreakpoints = {
  start: { size: 0, mq: '(max-width: 330px)' },
  xxs: { size: 330, mq: '(min-width: 330px) and (max-width: 350px)' },
  xs: { size: 350, mq: '(min-width: 350px) and (max-width: 366px)' },
  sm: { size: 366, mq: '(min-width: 366px) and (max-width: 432px)' },
  md: { size: 432, mq: '(min-width: 432px) and (max-width: 672px)' },
  lg: { size: 672, mq: '(min-width: 672px) and (max-width: 758px)' },
  xl: { size: 758, mq: '(min-width: 758px) and (max-width: 1002px)' },
  xxl: { size: 1002, mq: '(min-width: 1002px) and (max-width: 1024px)' },
  xxxl: { size: 1024, mq: '(min-width: 1024px) and (max-width: 1267px)' }, // introduction of side menu
  xxxxl: {
    size: 1267,
    mq: '(min-width: 1267px) and (max-width: 1350px)',
  },
  xxxxxl: {
    size: 1350,
    mq: '(min-width: 1350px) and (max-width: 1660px)',
  },
  end: { size: 1660, mq: '(min-width: 1660px)' },
}

// size mapping array to be filled later, but this way we can access it globally
var sizeMapping = {
  leftRight: null,
  top: null,
  inContent: null,
  anchor: null,
  bottom: null,
}

googletag.cmd.push(function () {
  // size mapping specifically for vertical ads used left & right
  sizeMapping.leftRight = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.end.size, 0],
      [
        [300, 600],
        [300, 250],
        [160, 600],
      ]
    )
    .addSize([adBreakpoints.xxxxxl.size, 0], [[160, 600]])
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping specifically for horizontal ads at the top
  // to make sure the top ads only impact a minimal vertical space
  sizeMapping.top = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxxxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
      ]
    )
    .addSize([adBreakpoints.xxxl.size, 0], [[728, 90]])
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
      ]
    )
    .addSize([adBreakpoints.xl.size, 0], [[728, 90]])
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [320, 100],
        [320, 50],
        [320, 180],
        [300, 100],
        [300, 50],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping for all in content ads
  sizeMapping.inContent = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.end.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
        [640, 480],
        [640, 360],
      ]
    )
    .addSize(
      [adBreakpoints.xl.size, 0],
      [
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
        [336, 280],
        [336, 336],
        [300, 250],
      ]
    )
    .addSize(
      [adBreakpoints.lg.size, 0],
      [
        [640, 480],
        [640, 360],
        [400, 300],
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 180],
        [320, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.md.size, 0],
      [
        [400, 300],
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 180],
        [320, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.sm.size, 0],
      [
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 180],
        [320, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping for all anchor ads
  sizeMapping.anchor = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [728, 90],
      ]
    )
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [970, 90],
        [728, 90],
      ]
    )
    .addSize([adBreakpoints.xl.size, 0], [[728, 90]])
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 50],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping specifically for horizontal ads at the bottom
  sizeMapping.bottom = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxxxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
        [640, 480],
        [640, 360],
      ]
    )
    .addSize(
      [adBreakpoints.xxxl.size, 0],
      [
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
      ]
    )
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
      ]
    )
    .addSize(
      [adBreakpoints.xl.size, 0],
      [
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
      ]
    )
    .addSize(
      [adBreakpoints.lg.size, 0],
      [
        [640, 480],
        [640, 360],
        [400, 300],
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.md.size, 0],
      [
        [400, 300],
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.sm.size, 0],
      [
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // defining the main static slots
  googletag
    .defineSlot(
      '/22809915073/SingleCare_Conditions/conditions-treatments-page_top',
      getAllAdSizes(sizeMapping.top),
      'div-gpt-ad-1694716106511-0'
    )
    .defineSizeMapping(sizeMapping.top)
    .addService(googletag.pubads())
  googletag
    .defineSlot(
      '/22809915073/SingleCare_Conditions/conditions-treatments-page_bottom',
      getAllAdSizes(sizeMapping.bottom),
      'div-gpt-ad-1694716566013-0'
    )
    .defineSizeMapping(sizeMapping.bottom)
    .addService(googletag.pubads())

  googletag
    .defineSlot(
      '/22809915073/SingleCare_Conditions/conditions-treatments-page_bottom-anchor',
      getAllAdSizes(sizeMapping.anchor),
      'div-gpt-ad-1694716740577-0'
    )
    .defineSizeMapping(sizeMapping.anchor)
    .addService(googletag.pubads())

  // targeting variables
  // left this unchanged
  var aid_nameMeta = document.querySelector("meta[property='aid_name']")
  if (aid_nameMeta) {
    googletag
      .pubads()
      .setTargeting('aid_name', aid_nameMeta.content.slice(0, 40))
  }

  var placement_nameMeta = document.querySelector(
    "meta[property='placement_name']"
  )
  if (placement_nameMeta) {
    googletag
      .pubads()
      .setTargeting(
        'placement_name',
        placement_nameMeta.content.slice(0, 40)
      )
  }

  var environmentMeta = document.querySelector(
    "meta[property='environment']"
  )
  if (environmentMeta) {
    googletag
      .pubads()
      .setTargeting('environment', environmentMeta.content.slice(0, 40))
  }

  var logged_inMeta = document.querySelector("meta[property='logged_in']")
  if (logged_inMeta) {
    googletag
      .pubads()
      .setTargeting('logged_in', logged_inMeta.content.slice(0, 40))
  }

  googletag.pubads().enableSingleRequest()
  googletag.pubads().collapseEmptyDivs()
  googletag.pubads().setCentering(true);
  adSlotsBorder();
  googletag.enableServices()
});`;

export const CONDITIONS_TREATMENT_PAGE_VERTICAL_RIGHT_SIDE_ADS =
  sizeMapping => {
    return [
      {
        path: '/22809915073/SingleCare_Conditions/conditions-treatments-page_right-hand_1st',
        id: 'div-gpt-ad-1694716684864-0',
        size: sizeMapping
      },
      {
        path: '/22809915073/SingleCare_Conditions/conditions-treatments-page_right-hand_2nd',
        id: 'div-gpt-ad-1694716690070-0',
        size: sizeMapping
      },
      {
        path: '/22809915073/SingleCare_Conditions/conditions-treatments-page_right-hand_3rd',
        id: 'div-gpt-ad-1694716696581-0',
        size: sizeMapping
      },
      {
        path: '/22809915073/SingleCare_Conditions/conditions-treatments-page_right-hand_4th',
        id: 'div-gpt-ad-1694716700025-0',
        size: sizeMapping
      },
      {
        path: '/22809915073/SingleCare_Conditions/conditions-treatments-page_right-hand_5th',
        id: 'div-gpt-ad-1694716735856-0',
        size: sizeMapping
      }
    ];
  };

export const CONDITIONS_TREATMENT_PAGE_VERTICAL_LEFT_SIDE_ADS = sizeMapping => {
  return [
    {
      path: '/22809915073/SingleCare_Conditions/conditions-treatments-page_left_1st',
      id: 'div-gpt-ad-1707256692076-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Conditions/conditions-treatments-page_left_2nd',
      id: 'div-gpt-ad-1707256773630-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Conditions/conditions-treatments-page_left_3rd',
      id: 'div-gpt-ad-1707257948258-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Conditions/conditions-treatments-page_left_4th',
      id: 'div-gpt-ad-1707258178684-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Conditions/conditions-treatments-page_left_5th',
      id: 'div-gpt-ad-1707258238154-0',
      size: sizeMapping
    }
  ];
};

export const CONDITIONS_TREATMENT_PAGE_HORIZONTAL_ADS = sizeMapping => {
  return [
    {
      path: '/22809915073/SingleCare_Conditions/conditions-treatments-page_in-content-1st',
      id: 'div-gpt-ad-1694716207173-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Conditions/conditions-treatments-page_in-content-2nd',
      id: 'div-gpt-ad-1694716283749-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Conditions/conditions-treatments-page_in-content-3rd',
      id: 'div-gpt-ad-1694716353951-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Conditions/conditions-treatments-page_in-content-4th',
      id: 'div-gpt-ad-1694716423940-0',
      size: sizeMapping
    },
    {
      path: '/22809915073/SingleCare_Conditions/conditions-treatments-page_in-content-5th',
      id: 'div-gpt-ad-1694716493681-0',
      size: sizeMapping
    }
  ];
};

export const GPT_HEAD_CONDITIONS_ADD_ON_PAGE = slugType => `
const type = '${slugType}';

// list of all breakpoints we are using in the ads
// size property corresponds to sizeMapping used in the ad slots
// mq property lists the mediaquery this size should be visible to
const adBreakpoints = {
  start: { size: 0, mq: '(max-width: 350px)' },
  xxs: { size: 350, mq: '(min-width: 350px) and (max-width: 370px)' },
  xs: { size: 370, mq: '(min-width: 370px) and (max-width: 386px)' },
  sm: { size: 386, mq: '(min-width: 386px) and (max-width: 450px)' },
  md: { size: 450, mq: '(min-width: 450px) and (max-width: 690px)' },
  lg: { size: 690, mq: '(min-width: 690px) and (max-width: 778px)' },
  xl: { size: 778, mq: '(min-width: 778px) and (max-width: 1030px)' },
  xxl: { size: 1030, mq: '(min-width: 1030px) and (max-width: 1380px)' },
  xxxl: {
    size: 1380,
    mq: '(min-width: 1380px) and (max-width: 1492px)',
  },
  xxxxl: {
    size: 1492,
    mq: '(min-width: 1492px) and (max-width: 1700px)',
  },
  end: { size: 1700, mq: '(min-width: 1700px)' },
}

// size mapping array to be filled later, but this way we can access it globally
var sizeMapping = {
  leftRight: null,
  top: null,
  inContent: null,
  anchor: null,
  bottom: null
}
googletag.cmd.push(function () {
  // size mapping specifically for vertical ads used left & right
  sizeMapping.leftRight = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.end.size, 0],
      [
        [300, 600],
        [300, 250],
        [160, 600],
      ]
    )
    .addSize([adBreakpoints.xxxxl.size, 0], [[160, 600]])
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping specifically for horizontal ads at the top
  // to make sure the top ads only impact a minimal vertical space
  sizeMapping.top = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
      ]
    )
    .addSize([adBreakpoints.xl.size, 0], [[728, 90]])
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [320, 50],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping for all in content ads
  sizeMapping.inContent = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxxxl.size, 0],
      [
        [970, 250],
        [970, 90],
        [980, 120],
        [728, 90],
        [640, 480],
        [640, 360],
      ]
    )
    .addSize(
      [adBreakpoints.xl.size, 0],
      [
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
        [336, 280],
        [336, 336],
        [300, 250],
      ]
    )
    .addSize(
      [adBreakpoints.lg.size, 0],
      [
        [640, 480],
        [640, 360],
        [400, 300],
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 180],
        [320, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.md.size, 0],
      [
        [400, 300],
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 180],
        [320, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.sm.size, 0],
      [
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping for all anchor ads
  sizeMapping.anchor = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [728, 90],
      ]
    )
    .addSize([adBreakpoints.xl.size, 0], [[728, 90]])
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 50],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // size mapping specifically for horizontal ads at the bottom
  sizeMapping.bottom = googletag
    .sizeMapping()
    .addSize(
      [adBreakpoints.xxl.size, 0],
      [
        [980, 120],
        [970, 90],
        [970, 250],
        [728, 90],
        [640, 480],
        [640, 360],
      ]
    )
    .addSize(
      [adBreakpoints.xl.size, 0],
      [
        [728, 90],
        [640, 480],
        [640, 360],
        [400, 300],
      ]
    )
    .addSize(
      [adBreakpoints.lg.size, 0],
      [
        [640, 480],
        [640, 360],
        [400, 300],
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.md.size, 0],
      [
        [400, 300],
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.sm.size, 0],
      [
        [336, 280],
        [336, 336],
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xs.size, 0],
      [
        [320, 50],
        [300, 50],
        [300, 100],
        [320, 100],
        [320, 180],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize(
      [adBreakpoints.xxs.size, 0],
      [
        [300, 50],
        [300, 100],
        [300, 250],
        [250, 250],
        [200, 200],
      ]
    )
    .addSize([adBreakpoints.start.size, 0], [])
    .build()

  // defining the main static slots of symptoms page
  if(type === 'symptoms'){
    googletag
      .defineSlot(
        '/22809915073/SingleCare_Conditions/conditions-symptoms-page_top',
        getAllAdSizes(sizeMapping.top),
        'div-gpt-ad-1694719068330-0'
      )
      .defineSizeMapping(sizeMapping.top)
      .addService(googletag.pubads())
    googletag
      .defineSlot(
        '/22809915073/SingleCare_Conditions/conditions-symptoms-page_bottom',
        getAllAdSizes(sizeMapping.bottom),
        'div-gpt-ad-1694719095144-0'
      )
      .defineSizeMapping(sizeMapping.inContent)
      .addService(googletag.pubads())
    googletag
      .defineSlot(
        '/22809915073/SingleCare_Conditions/conditions-symptoms-page_bottom-anchor',
        getAllAdSizes(sizeMapping.anchor),
        'div-gpt-ad-1694719594975-0'
      )
      .defineSizeMapping(sizeMapping.anchor)
      .addService(googletag.pubads())
  }
  // defining the main static slots for causes page
  if(type === 'causes'){
    googletag
      .defineSlot(
        '/22809915073/SingleCare_Conditions/conditions-causes-page_top',
        getAllAdSizes(sizeMapping.top),
        'div-gpt-ad-1694721278359-0'
      )
      .defineSizeMapping(sizeMapping.top)
      .addService(googletag.pubads())
    googletag
      .defineSlot(
        '/22809915073/SingleCare_Conditions/conditions-causes-page_bottom',
        getAllAdSizes(sizeMapping.inContent),
        'div-gpt-ad-1694721306141-0'
      )
      .defineSizeMapping(sizeMapping.inContent)
      .addService(googletag.pubads())
    googletag
      .defineSlot(
        '/22809915073/SingleCare_Conditions/conditions-causes-page_bottom-anchor',
        getAllAdSizes(sizeMapping.anchor),
        'div-gpt-ad-1694721309299-0'
      )
      .defineSizeMapping(sizeMapping.anchor)
      .addService(googletag.pubads())
  }
  
  // targeting variables
  var placement_nameMeta = document.querySelector(
    "meta[property='placement_name']"
  )
  if (placement_nameMeta) {
    googletag
      .pubads()
      .setTargeting(
        'placement_name',
        placement_nameMeta.content.slice(0, 40)
      )
  }

  var aid_nameMeta = document.querySelector("meta[property='aid_name']")
  if (aid_nameMeta) {
    googletag
      .pubads()
      .setTargeting('aid_name', aid_nameMeta.content.slice(0, 40))
  }

  var environmentMeta = document.querySelector(
    "meta[property='environment']"
  )
  if (environmentMeta) {
    googletag
      .pubads()
      .setTargeting('environment', environmentMeta.content.slice(0, 40))
  }

  var logged_inMeta = document.querySelector("meta[property='logged_in']")
  if (logged_inMeta) {
    googletag
      .pubads()
      .setTargeting('logged_in', logged_inMeta.content.slice(0, 40))
  }

  googletag.pubads().enableSingleRequest()
  googletag.pubads().collapseEmptyDivs()
  googletag.pubads().setCentering(true);
  adSlotsBorder();
  googletag.enableServices()
});`;

const CONDITIONS_SYMPTOMS_PAGE_VERTICAL_RIGHT_SIDE_ADS = sizeMapping => [
  {
    path: '/22809915073/SingleCare_Conditions/conditions-symptoms-page_right-hand_1st',
    id: 'div-gpt-ad-1694719558351-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-symptoms-page_right-hand_2nd',
    id: 'div-gpt-ad-1694719565957-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-symptoms-page_right-hand_3rd',
    id: 'div-gpt-ad-1694719574957-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-symptoms-page_right-hand_4th',
    id: 'div-gpt-ad-1694719582827-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-symptoms-page_right-hand_5th',
    id: 'div-gpt-ad-1694719591082-0',
    size: sizeMapping
  }
];

const CONDITIONS_SYMPTOMS_PAGE_VERTICAL_LEFT_SIDE_ADS = sizeMapping => [
  {
    path: '/22809915073/SingleCare_Conditions/conditions-symptoms-page_left-hand_1st',
    id: 'div-gpt-ad-1694719554573-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-symptoms-page_left-hand_2nd',
    id: 'div-gpt-ad-1694719562300-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-symptoms-page_left-hand_3rd',
    id: 'div-gpt-ad-1694719570823-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-symptoms-page_left-hand_4th',
    id: 'div-gpt-ad-1694719578770-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-symptoms-page_left-hand_5th',
    id: 'div-gpt-ad-1694719586240-0',
    size: sizeMapping
  }
];

const CONDITIONS_SYMPTOMS_PAGE_HORIZONTAL_ADS = sizeMapping => [
  {
    path: '/22809915073/SingleCare_Conditions/conditions-symptoms-page_in-content-1st',
    id: 'div-gpt-ad-1694719072208-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-symptoms-page_in-content-2nd',
    id: 'div-gpt-ad-1694719077642-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-symptoms-page_in-content-3rd',
    id: 'div-gpt-ad-1694719082297-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-symptoms-page_in-content-4th',
    id: 'div-gpt-ad-1694719086848-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-symptoms-page_in-content-5th',
    id: 'div-gpt-ad-1694719091231-0',
    size: sizeMapping
  }
];

const CONDITIONS_CAUSES_PAGE_VERTICAL_RIGHT_SIDE_ADS = sizeMapping => [
  {
    path: '/22809915073/SingleCare_Conditions/conditions-causes-page_right-hand_1st',
    id: 'div-gpt-ad-1694721893621-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-causes-page_right-hand_2nd',
    id: 'div-gpt-ad-1694721903739-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-causes-page_right-hand_3rd',
    id: 'div-gpt-ad-1694721911877-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-causes-page_right-hand_4th',
    id: 'div-gpt-ad-1694721920061-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-causes-page_right-hand_5th',
    id: 'div-gpt-ad-1694721927811-0',
    size: sizeMapping
  }
];

const CONDITIONS_CAUSES_PAGE_VERTICAL_LEFT_SIDE_ADS = sizeMapping => [
  {
    path: '/22809915073/SingleCare_Conditions/conditions-causes-page_left-hand_1st',
    id: 'div-gpt-ad-1694721889168-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-causes-page_left-hand_2nd',
    id: 'div-gpt-ad-1694721898717-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-causes-page_left-hand_3rd',
    id: 'div-gpt-ad-1694721907756-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-causes-page_left-hand_4th',
    id: 'div-gpt-ad-1694721916260-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-causes-page_left-hand_5th',
    id: 'div-gpt-ad-1694721924233-0',
    size: sizeMapping
  }
];
const CONDITIONS_CAUSES_PAGE_HORIZONTAL_ADS = sizeMapping => [
  {
    path: '/22809915073/SingleCare_Conditions/conditions-causes-page_in-content-1st',
    id: 'div-gpt-ad-1694721283388-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-causes-page_in-content-2nd',
    id: 'div-gpt-ad-1694721287350-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-causes-page_in-content-3rd',
    id: 'div-gpt-ad-1694721292769-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-causes-page_in-content-4th',
    id: 'div-gpt-ad-1694721296639-0',
    size: sizeMapping
  },
  {
    path: '/22809915073/SingleCare_Conditions/conditions-causes-page_in-content-5th',
    id: 'div-gpt-ad-1694721301853-0',
    size: sizeMapping
  }
];

export const CONDITIONS_ADD_ON_PAGE_ADS = sizeMapping => {
  return {
    symptoms: {
      RIGHT_SIDE: CONDITIONS_SYMPTOMS_PAGE_VERTICAL_RIGHT_SIDE_ADS(sizeMapping),
      LEFT_SIDE: CONDITIONS_SYMPTOMS_PAGE_VERTICAL_LEFT_SIDE_ADS(sizeMapping),
      IN_CONTENT: CONDITIONS_SYMPTOMS_PAGE_HORIZONTAL_ADS(sizeMapping)
    },
    causes: {
      RIGHT_SIDE: CONDITIONS_CAUSES_PAGE_VERTICAL_RIGHT_SIDE_ADS(sizeMapping),
      LEFT_SIDE: CONDITIONS_CAUSES_PAGE_VERTICAL_LEFT_SIDE_ADS(sizeMapping),
      IN_CONTENT: CONDITIONS_CAUSES_PAGE_HORIZONTAL_ADS(sizeMapping)
    }
  };
};
